import React from "react"
import {
  Modal,
  ModalCard,
  StyledModal,
  StyledModalHeader,
  StyledModalBody,
  StyledModalActions,
  Button,
  Spacer,
  Text,
  useShowSuccessToast,
} from "gatsby-interface"
import { ModalMessage } from "@modules/modal"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { useRemoveCmsIntegration } from "../hooks/useRemoveCmsIntegration"

export function CmsIntegrationDeleteForm({ cms, onDismiss, siteId }) {
  const showSuccessToast = useShowSuccessToast()
  const [setError, errorAlert] = useTriggerErrorAlert()
  const removeCmsIntegration = useRemoveCmsIntegration(siteId, cms.name)

  const handleRemove = async () => {
    try {
      await removeCmsIntegration()

      showSuccessToast(
        <React.Fragment>
          <strong>CMS integration</strong> successfully deleted.
        </React.Fragment>
      )

      onDismiss()
    } catch (error) {
      setError(error)
    }
  }

  return (
    <Modal
      isOpen={Boolean(cms)}
      aria-label={`Do you want to remove the ${cms.name} integration?`}
      onDismiss={onDismiss}
      type="error"
    >
      <ModalCard>
        <StyledModal variant="WARNING">
          <StyledModalHeader onCloseButtonClick={onDismiss}>
            Delete the CMS Integration?
          </StyledModalHeader>

          <StyledModalBody>
            <ModalMessage>
              <Text>
                Are you sure you want to delete the{" "}
                {cms.formattedName || cms.name} integration for this site?
              </Text>
            </ModalMessage>

            {errorAlert && (
              <React.Fragment>
                <Spacer size={7} />
                {errorAlert}
              </React.Fragment>
            )}

            <StyledModalActions>
              <Button
                data-testid="dismiss-deleteform-modal"
                type="button"
                onClick={onDismiss}
                tone="NEUTRAL"
                variant="SECONDARY"
              >
                Cancel
              </Button>
              <Button
                data-testid="remove-cms-integration"
                type="button"
                onClick={handleRemove}
                tone="DANGER"
                variant="PRIMARY"
              >
                Delete integration
              </Button>
            </StyledModalActions>
          </StyledModalBody>
        </StyledModal>
      </ModalCard>
    </Modal>
  )
}
